module.exports = __webpack_public_path__ + "img/Small house logo Icon - white.1d07044c.svg";